import axios from 'axios';

export const getHighlighted = async () => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    try {
        const params = new URLSearchParams({ statut: '1' });
        params.append('en_avant', '1');
        params.append('itemsPerPage', '4');

        const response = await axios.get(`${apiUrl}/front_formations?${params}`);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des formations "en avant":', error);
        throw error;
    }
};